var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 248,
    viewBox: "0 0 257 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.893 132.235C219.893 132.235 233.733 127.665 239.873 117.905C240.203 117.385 240.833 117.125 241.443 117.245C242.423 117.435 242.963 118.505 242.523 119.405C240.263 124.045 233.093 136.315 219.213 139.705C206.263 142.865 219.893 132.235 219.893 132.235Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M229.564 151.295C231.486 151.295 233.044 149.737 233.044 147.815C233.044 145.893 231.486 144.335 229.564 144.335C227.642 144.335 226.084 145.893 226.084 147.815C226.084 149.737 227.642 151.295 229.564 151.295Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M229.564 150.455C231.022 150.455 232.204 149.273 232.204 147.815C232.204 146.357 231.022 145.175 229.564 145.175C228.106 145.175 226.924 146.357 226.924 147.815C226.924 149.273 228.106 150.455 229.564 150.455Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M229.564 149.615C230.558 149.615 231.364 148.809 231.364 147.815C231.364 146.821 230.558 146.015 229.564 146.015C228.57 146.015 227.764 146.821 227.764 147.815C227.764 148.809 228.57 149.615 229.564 149.615Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M229.564 148.775C230.094 148.775 230.524 148.345 230.524 147.815C230.524 147.285 230.094 146.855 229.564 146.855C229.033 146.855 228.604 147.285 228.604 147.815C228.604 148.345 229.033 148.775 229.564 148.775Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.344 63.4352C183.409 63.4352 185.894 60.9504 185.894 57.8852C185.894 54.82 183.409 52.3352 180.344 52.3352C177.279 52.3352 174.794 54.82 174.794 57.8852C174.794 60.9504 177.279 63.4352 180.344 63.4352Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.344 62.0952C182.669 62.0952 184.554 60.2103 184.554 57.8852C184.554 55.5601 182.669 53.6752 180.344 53.6752C178.019 53.6752 176.134 55.5601 176.134 57.8852C176.134 60.2103 178.019 62.0952 180.344 62.0952Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.344 60.7553C181.929 60.7553 183.214 59.4703 183.214 57.8853C183.214 56.3002 181.929 55.0153 180.344 55.0153C178.759 55.0153 177.474 56.3002 177.474 57.8853C177.474 59.4703 178.759 60.7553 180.344 60.7553Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.344 59.4252C181.194 59.4252 181.884 58.7357 181.884 57.8852C181.884 57.0347 181.194 56.3452 180.344 56.3452C179.493 56.3452 178.804 57.0347 178.804 57.8852C178.804 58.7357 179.493 59.4252 180.344 59.4252Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.513 234.195C127.649 234.195 132.623 229.221 132.623 223.085C132.623 216.949 127.649 211.975 121.513 211.975C115.377 211.975 110.403 216.949 110.403 223.085C110.403 229.221 115.377 234.195 121.513 234.195Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.513 231.515C126.169 231.515 129.943 227.741 129.943 223.085C129.943 218.43 126.169 214.655 121.513 214.655C116.857 214.655 113.083 218.43 113.083 223.085C113.083 227.741 116.857 231.515 121.513 231.515Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.514 228.835C124.689 228.835 127.264 226.261 127.264 223.085C127.264 219.91 124.689 217.335 121.514 217.335C118.338 217.335 115.764 219.91 115.764 223.085C115.764 226.261 118.338 228.835 121.514 228.835Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.513 226.155C123.209 226.155 124.583 224.781 124.583 223.085C124.583 221.39 123.209 220.015 121.513 220.015C119.818 220.015 118.443 221.39 118.443 223.085C118.443 224.781 119.818 226.155 121.513 226.155Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.7833 99.3352C65.1909 99.3352 67.9533 96.5728 67.9533 93.1652C67.9533 89.7576 65.1909 86.9952 61.7833 86.9952C58.3757 86.9952 55.6133 89.7576 55.6133 93.1652C55.6133 96.5728 58.3757 99.3352 61.7833 99.3352Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.7835 97.8452C64.3682 97.8452 66.4635 95.7499 66.4635 93.1652C66.4635 90.5805 64.3682 88.4852 61.7835 88.4852C59.1988 88.4852 57.1035 90.5805 57.1035 93.1652C57.1035 95.7499 59.1988 97.8452 61.7835 97.8452Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.783 96.3652C63.5503 96.3652 64.983 94.9325 64.983 93.1652C64.983 91.3979 63.5503 89.9652 61.783 89.9652C60.0157 89.9652 58.583 91.3979 58.583 93.1652C58.583 94.9325 60.0157 96.3652 61.783 96.3652Z",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.7832 94.8752C62.7276 94.8752 63.4932 94.1096 63.4932 93.1652C63.4932 92.2208 62.7276 91.4552 61.7832 91.4552C60.8388 91.4552 60.0732 92.2208 60.0732 93.1652C60.0732 94.1096 60.8388 94.8752 61.7832 94.8752Z",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.614 66.0153L103.104 59.2753L108.714 62.0253L104.614 66.0153Z",
    fill: "url(#paint17_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.104 66.0153L149.614 59.2753L144.014 62.0253L148.104 66.0153Z",
    fill: "url(#paint18_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8832 77.0753C90.2432 71.6853 94.0432 61.3053 94.0432 61.3053L104.603 66.0153L98.8832 77.0753Z",
    fill: "url(#paint19_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M153.833 77.0753C162.473 71.6853 158.673 61.3053 158.673 61.3053L148.113 66.0153L153.833 77.0753Z",
    fill: "url(#paint20_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M164.524 128.625H88.2036C86.9436 128.625 85.9336 127.605 85.9336 126.355V124.965C85.9336 123.705 86.9536 122.695 88.2036 122.695H164.524C165.784 122.695 166.794 123.715 166.794 124.965V126.355C166.804 127.605 165.784 128.625 164.524 128.625Z",
    fill: "url(#paint21_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M168.144 138.625H84.5936C82.5736 138.625 80.9336 136.985 80.9336 134.965V132.285C80.9336 130.265 82.5736 128.625 84.5936 128.625H168.144C170.164 128.625 171.804 130.265 171.804 132.285V134.965C171.804 136.985 170.164 138.625 168.144 138.625Z",
    fill: "url(#paint22_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.774 119.635V84.2752C154.774 68.5852 142.054 55.8752 126.374 55.8752C110.684 55.8752 97.9736 68.5952 97.9736 84.2752V119.635H154.774Z",
    fill: "url(#paint23_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.364 90.4152C133.416 90.4152 139.134 84.6979 139.134 77.6452C139.134 70.5926 133.416 64.8752 126.364 64.8752C119.311 64.8752 113.594 70.5926 113.594 77.6452C113.594 84.6979 119.311 90.4152 126.364 90.4152Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M126.363 86.2353C131.108 86.2353 134.953 82.3894 134.953 77.6453C134.953 72.9012 131.108 69.0553 126.363 69.0553C121.619 69.0553 117.773 72.9012 117.773 77.6453C117.773 82.3894 121.619 86.2353 126.363 86.2353Z",
    fill: "url(#paint24_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M126.363 83.1453C129.401 83.1453 131.863 80.6828 131.863 77.6453C131.863 74.6077 129.401 72.1453 126.363 72.1453C123.326 72.1453 120.863 74.6077 120.863 77.6453C120.863 80.6828 123.326 83.1453 126.363 83.1453Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M129.174 77.6453C130.72 77.6453 131.974 76.3917 131.974 74.8453C131.974 73.2989 130.72 72.0453 129.174 72.0453C127.628 72.0453 126.374 73.2989 126.374 74.8453C126.374 76.3917 127.628 77.6453 129.174 77.6453Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M132.204 73.3253C133.043 73.3253 133.724 72.6447 133.724 71.8053C133.724 70.9658 133.043 70.2853 132.204 70.2853C131.364 70.2853 130.684 70.9658 130.684 71.8053C130.684 72.6447 131.364 73.3253 132.204 73.3253Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.314 92.7952C110.987 92.7952 113.154 90.6283 113.154 87.9552C113.154 85.2822 110.987 83.1152 108.314 83.1152C105.641 83.1152 103.474 85.2822 103.474 87.9552C103.474 90.6283 105.641 92.7952 108.314 92.7952Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.313 91.2052C110.108 91.2052 111.563 89.7501 111.563 87.9552C111.563 86.1603 110.108 84.7052 108.313 84.7052C106.519 84.7052 105.063 86.1603 105.063 87.9552C105.063 89.7501 106.519 91.2052 108.313 91.2052Z",
    fill: "url(#paint25_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M108.313 90.0352C109.462 90.0352 110.393 89.104 110.393 87.9552C110.393 86.8065 109.462 85.8752 108.313 85.8752C107.165 85.8752 106.233 86.8065 106.233 87.9552C106.233 89.104 107.165 90.0352 108.313 90.0352Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.373 87.9552C109.959 87.9552 110.433 87.4806 110.433 86.8952C110.433 86.3098 109.959 85.8352 109.373 85.8352C108.788 85.8352 108.313 86.3098 108.313 86.8952C108.313 87.4806 108.788 87.9552 109.373 87.9552Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M110.523 86.3253C110.844 86.3253 111.103 86.0656 111.103 85.7453C111.103 85.425 110.844 85.1653 110.523 85.1653C110.203 85.1653 109.943 85.425 109.943 85.7453C109.943 86.0656 110.203 86.3253 110.523 86.3253Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M144.373 92.7952C147.046 92.7952 149.213 90.6283 149.213 87.9552C149.213 85.2822 147.046 83.1152 144.373 83.1152C141.7 83.1152 139.533 85.2822 139.533 87.9552C139.533 90.6283 141.7 92.7952 144.373 92.7952Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M144.373 91.2052C146.168 91.2052 147.623 89.7501 147.623 87.9552C147.623 86.1603 146.168 84.7052 144.373 84.7052C142.578 84.7052 141.123 86.1603 141.123 87.9552C141.123 89.7501 142.578 91.2052 144.373 91.2052Z",
    fill: "url(#paint26_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M144.373 90.0352C145.522 90.0352 146.453 89.104 146.453 87.9552C146.453 86.8065 145.522 85.8752 144.373 85.8752C143.224 85.8752 142.293 86.8065 142.293 87.9552C142.293 89.104 143.224 90.0352 144.373 90.0352Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M145.433 87.9552C146.018 87.9552 146.493 87.4806 146.493 86.8952C146.493 86.3098 146.018 85.8352 145.433 85.8352C144.848 85.8352 144.373 86.3098 144.373 86.8952C144.373 87.4806 144.848 87.9552 145.433 87.9552Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M146.583 86.3253C146.903 86.3253 147.163 86.0656 147.163 85.7453C147.163 85.425 146.903 85.1653 146.583 85.1653C146.263 85.1653 146.003 85.425 146.003 85.7453C146.003 86.0656 146.263 86.3253 146.583 86.3253Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M126.364 107.275C134.885 107.275 141.794 105.668 141.794 103.685C141.794 101.703 134.885 100.095 126.364 100.095C117.842 100.095 110.934 101.703 110.934 103.685C110.934 105.668 117.842 107.275 126.364 107.275Z",
    fill: "#251420"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M126.364 104.295C123.384 104.295 120.914 105.475 120.374 107.025C122.024 107.425 124.104 107.675 126.364 107.675C128.624 107.675 130.714 107.435 132.354 107.025C131.814 105.465 129.344 104.295 126.364 104.295Z",
    fill: "url(#paint27_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M117.623 106.645L117.983 107.635C118.333 108.595 119.723 108.505 119.943 107.505L120.063 106.965L121.513 100.285C119.273 100.455 117.263 100.745 115.613 101.115L117.623 106.645Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131.213 100.285L132.663 106.965L132.783 107.505C133.003 108.505 134.393 108.595 134.743 107.635L135.103 106.645L137.113 101.115C135.463 100.745 133.453 100.455 131.213 100.285Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M221.114 139.175C221.064 138.575 220.984 137.985 220.894 137.455C220.644 135.935 220.844 134.365 221.424 132.935L222.054 131.405L219.894 132.235L217.954 134.075L219.214 139.705L221.114 139.175Z",
    fill: "#24154C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M121.513 100.285C119.273 100.455 117.263 100.745 115.613 101.115L116.233 102.815C117.653 102.525 119.303 102.305 121.103 102.145L121.513 100.285Z",
    fill: "#131223"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M137.114 101.115C135.464 100.745 133.454 100.455 131.214 100.285L131.624 102.155C133.434 102.305 135.074 102.535 136.494 102.825L137.114 101.115Z",
    fill: "#131223"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0438 148.485C52.0438 148.485 56.2138 164.655 71.4238 164.105C90.4138 163.425 94.5538 144.265 95.1338 138.615H112.164C112.164 138.615 108.314 175.355 73.7638 178.175C45.1238 180.515 37.3838 149.625 37.3838 149.625L52.0438 148.485Z",
    fill: "url(#paint28_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7833 151.765L6.78334 118.295C6.55334 116.405 7.90333 114.685 9.80333 114.455L62.4133 108.175C64.3033 107.945 66.0233 109.295 66.2533 111.195L70.2533 144.665C70.4833 146.555 69.1333 148.275 67.2333 148.505L14.6233 154.785C12.7233 155.005 11.0133 153.655 10.7833 151.765Z",
    fill: "url(#paint29_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9937 140.505C54.9737 134.175 53.8737 124.975 47.5437 119.995C44.4737 117.585 40.6537 116.505 36.7837 116.975C32.9137 117.435 29.4437 119.385 27.0337 122.445C24.5437 125.605 23.5737 129.495 24.0137 133.205C24.4537 136.915 26.3137 140.465 29.4737 142.955C32.5437 145.365 36.3637 146.445 40.2337 145.975C44.1037 145.505 47.5837 143.575 49.9937 140.505ZM30.7537 141.355C25.3037 137.075 24.3637 129.155 28.6437 123.705C30.7237 121.065 33.6937 119.395 37.0337 118.995C40.3737 118.595 43.6537 119.525 46.2937 121.595C49.0137 123.735 50.6137 126.785 50.9937 129.985C51.3737 133.185 50.5437 136.525 48.3937 139.245C46.3137 141.885 43.3437 143.555 40.0037 143.955C36.6637 144.355 33.3837 143.435 30.7537 141.355Z",
    fill: "url(#paint30_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4737 135.375C43.8237 134.935 43.7437 134.295 43.3037 133.945L39.9437 131.305L42.5837 127.945C42.9337 127.505 42.8537 126.865 42.4137 126.515C41.9737 126.165 41.3337 126.245 40.9837 126.685L38.3437 130.045L34.9837 127.405C34.5437 127.055 33.9037 127.135 33.5537 127.575C33.3837 127.795 33.3137 128.065 33.3437 128.325C33.3737 128.585 33.5037 128.835 33.7237 129.005L37.0837 131.645L34.4437 135.005C34.2737 135.225 34.2037 135.495 34.2337 135.755C34.2637 136.015 34.3937 136.265 34.6137 136.435C35.0537 136.785 35.6937 136.705 36.0437 136.265L38.6837 132.905L42.0437 135.545C42.4837 135.895 43.1237 135.825 43.4737 135.375Z",
    fill: "url(#paint31_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.4932 135.575C18.4932 135.575 35.3632 133.745 38.9532 110.985L36.0532 111.335L18.4932 135.575Z",
    fill: "#131223"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0636 109.895C46.7636 103.325 43.9336 99.1552 37.3836 99.2752C22.1336 99.5452 25.0136 127.535 14.3436 129.785C8.79362 130.955 4.86362 125.655 3.32362 123.105C2.88362 122.375 1.96362 122.115 1.21362 122.505C0.48362 122.875 0.15362 123.715 0.42362 124.485C1.73362 128.185 6.41362 138.005 18.4936 135.585C32.8936 132.705 36.0436 111.335 36.0436 111.335L48.0636 109.895Z",
    fill: "url(#paint32_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M206.853 157.835L178.933 145.335C178.213 145.015 177.883 144.165 178.213 143.435L198.133 98.9352C198.453 98.2152 199.303 97.8852 200.033 98.2152L227.953 110.715C228.673 111.035 229.003 111.885 228.673 112.615L208.753 157.115C208.433 157.835 207.583 158.165 206.853 157.835Z",
    fill: "url(#paint33_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M188.214 121.015C192.764 121.025 208.374 124.875 202.364 147.135C201.714 149.545 201.034 151.555 199.394 154.505L203.434 156.315L210.574 146.355L203.434 121.015C203.444 121.015 193.754 119.295 188.214 121.015Z",
    fill: "#24154C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M218.103 151.515C216.833 157.535 209.413 180.785 179.793 179.625C146.023 178.305 141.483 138.615 141.483 138.615H158.513C159.093 144.265 165.383 164.265 182.013 165.025C197.313 165.725 202.813 155.355 204.473 151.075C206.143 146.795 212.173 120.315 188.203 121.005L183.093 132.305C183.093 132.305 177.173 117.155 186.993 111.935C198.173 106.015 224.953 118.975 218.103 151.515Z",
    fill: "url(#paint34_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M112.164 138.625C112.164 138.625 109.874 163.155 102.534 175.745C86.4436 203.355 66.6336 196.875 48.9736 209.055C29.1636 222.725 39.9236 257.875 70.4736 244.235C71.7836 243.655 72.3036 242.065 71.5936 240.825C71.0836 239.925 70.0536 239.455 69.0436 239.655C64.0936 240.615 49.7536 242.305 48.6036 229.725C46.4736 206.455 88.8636 216.125 109.364 191.385C130.424 165.975 126.354 145.735 126.354 138.635H112.164V138.625Z",
    fill: "url(#paint35_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M141.493 138.625C141.493 138.625 147.823 223.115 198.763 227.965C209.063 228.945 222.363 225.425 232.183 210.715C232.733 209.885 233.803 209.575 234.713 209.975C235.773 210.445 236.243 211.685 235.753 212.735C232.893 218.885 222.303 237.525 198.753 237.525C126.363 237.525 126.363 138.615 126.363 138.615",
    fill: "url(#paint36_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7341 215.835L2.32405 201.605C1.02405 200.475 0.884052 198.495 2.01405 197.195L25.2541 170.415C26.3841 169.115 28.3641 168.975 29.6641 170.105L46.0741 184.345C47.3741 185.475 47.5141 187.455 46.3841 188.755L23.1441 215.535C22.0141 216.835 20.034 216.975 18.7341 215.835Z",
    fill: "url(#paint37_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 188.355L219.383 172.375C218.873 171.105 219.483 169.655 220.753 169.145L246.833 158.635C248.103 158.125 249.553 158.735 250.063 160.005L256.503 175.985C257.013 177.255 256.403 178.705 255.133 179.215L229.053 189.725C227.783 190.245 226.343 189.625 225.823 188.355Z",
    fill: "url(#paint38_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M182.554 90.7952L177.034 84.1852C176.594 83.6552 176.664 82.8752 177.194 82.4352L187.994 73.4252C188.524 72.9852 189.304 73.0552 189.744 73.5852L195.264 80.1952C195.704 80.7252 195.634 81.5052 195.104 81.9452L184.304 90.9552C183.774 91.3852 182.994 91.3152 182.554 90.7952Z",
    fill: "url(#paint39_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M158.514 138.625H95.1338L94.3838 142.895L158.724 139.985L158.514 138.625Z",
    fill: "#131223"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.453 111.945V79.4953C167.453 56.8053 149.063 38.4053 126.363 38.4053C103.673 38.4053 85.2734 56.7953 85.2734 79.4953V111.955L97.9534 119.645H154.763L167.453 111.945Z",
    fill: "url(#paint40_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M168.644 119.655L174.434 104.935C175.004 103.475 174.234 101.835 172.744 101.355C171.944 101.095 171.064 101.225 170.374 101.695L153.724 113.055C150.344 115.355 146.354 116.595 142.264 116.595H126.364H110.464C106.374 116.595 102.384 115.365 99.0037 113.055L82.3637 101.695C81.6637 101.225 80.7937 101.095 79.9937 101.355C78.5037 101.835 77.7237 103.485 78.3037 104.935L84.0937 119.655C84.8137 121.475 86.5737 122.675 88.5337 122.675H164.204C166.164 122.675 167.924 121.475 168.644 119.655Z",
    fill: "url(#paint41_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M134.344 39.1853C134.344 34.9553 130.914 31.5253 126.684 31.5253H126.364H126.044C121.814 31.5253 118.384 34.9553 118.384 39.1853",
    fill: "url(#paint42_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M126.364 38.4053C116.964 38.4053 108.304 41.5753 101.374 46.8853H151.344C144.434 41.5753 135.774 38.4053 126.364 38.4053Z",
    fill: "url(#paint43_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.1133 151.975L52.6233 150.245L53.1333 151.475L39.2633 155.015L38.1133 151.975Z",
    fill: "#131223"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M29.124 180.255C27.514 178.855 25.084 179.035 23.684 180.645C22.284 182.255 22.464 184.685 24.064 186.085C25.674 187.485 28.114 187.315 29.504 185.705C30.914 184.085 30.734 181.645 29.124 180.255Z",
    fill: "url(#paint44_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8935 184.355C36.3135 182.995 32.9936 184.025 30.6636 186.695C28.3536 189.365 27.7936 192.765 29.4736 195.125C29.9936 195.865 30.9735 196.115 31.7835 195.705C33.1635 195.015 34.9236 193.455 36.4736 191.725C37.9736 189.935 39.2835 187.955 39.7635 186.485C40.0335 185.665 39.6635 184.755 38.8935 184.355Z",
    fill: "url(#paint45_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8839 192.655C19.3239 192.175 18.4839 192.235 18.0039 192.785L10.9739 200.895C10.4939 201.455 10.5539 202.295 11.1039 202.775C11.6539 203.255 12.5039 203.195 12.9839 202.645L20.0139 194.535C20.5039 193.975 20.4439 193.135 19.8839 192.655Z",
    fill: "#3AD4DC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7942 196.925L18.4642 201.925C17.9842 202.485 18.0442 203.325 18.5942 203.805C19.1542 204.285 19.9942 204.225 20.4742 203.675L24.8042 198.675C25.2842 198.115 25.2242 197.275 24.6742 196.795C24.1142 196.315 23.2742 196.375 22.7942 196.925Z",
    fill: "#3AD4DC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M200.064 133.125L190.274 128.735C189.604 128.435 188.814 128.735 188.514 129.405C188.214 130.075 188.514 130.865 189.184 131.165L198.974 135.555C199.644 135.855 200.434 135.555 200.734 134.885C201.034 134.215 200.734 133.425 200.064 133.125Z",
    fill: "url(#paint46_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M193.724 137.215L187.694 134.505C187.024 134.205 186.234 134.505 185.934 135.175C185.634 135.845 185.934 136.635 186.604 136.935L192.634 139.645C193.304 139.945 194.094 139.645 194.394 138.975C194.694 138.305 194.394 137.515 193.724 137.215Z",
    fill: "url(#paint47_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M210.564 109.805L200.774 105.415C200.104 105.115 199.314 105.415 199.014 106.085C198.714 106.755 199.014 107.545 199.684 107.845L209.474 112.235C210.144 112.535 210.934 112.235 211.234 111.565C211.534 110.895 211.234 110.105 210.564 109.805Z",
    fill: "#3AD4DC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M248.553 44.7552C245.553 53.8652 222.103 54.3152 196.173 45.7752C170.243 37.2352 151.663 22.9152 154.673 13.8152C157.683 4.71523 181.123 4.25523 207.053 12.7952C232.983 21.3352 251.553 35.6452 248.553 44.7552Z",
    fill: "url(#paint48_linear)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.554 44.7553C251.554 35.6453 232.974 21.3353 207.054 12.7953C181.134 4.24527 157.684 4.70527 154.674 13.8153C153.714 16.7453 154.974 20.2053 157.994 23.8453C157.104 21.9753 156.874 20.2153 157.394 18.6453C160.054 10.5653 181.494 10.3653 205.274 18.1953C229.054 26.0353 246.164 38.9353 243.504 47.0253C242.984 48.6053 241.754 49.8753 239.924 50.8553C244.514 49.7153 247.584 47.6753 248.554 44.7553Z",
    fill: "url(#paint49_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M197.473 10.0053C199.033 10.3953 200.623 10.8253 202.213 11.2953C203.813 11.7553 205.423 12.2553 207.043 12.7953C207.853 13.0653 208.653 13.3353 209.453 13.6153C211.043 14.1753 212.603 14.7453 214.133 15.3453C214.893 15.6453 215.653 15.9453 216.393 16.2553C217.883 16.8653 219.343 17.4953 220.753 18.1453C223.583 19.4353 226.263 20.7853 228.753 22.1653C229.023 22.3153 229.273 22.4653 229.533 22.6053C229.913 14.4053 222.193 5.57525 210.663 1.77525C199.143 -2.02475 187.683 0.485253 183.113 7.30525C184.113 7.42525 185.123 7.55525 186.153 7.71525C189.773 8.25525 193.563 9.02525 197.473 10.0053Z",
    fill: "url(#paint50_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M222.163 43.0853C220.833 47.1353 209.613 47.0753 197.103 42.9553C184.593 38.8353 175.543 32.2053 176.873 28.1553C178.203 24.1053 189.423 24.1653 201.933 28.2853C214.443 32.4053 223.503 39.0353 222.163 43.0853Z",
    fill: "url(#paint51_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.233 24.6352C207.933 25.5452 205.633 25.5952 203.103 24.7652C200.573 23.9352 198.753 22.5152 199.053 21.6152C199.353 20.7052 201.653 20.6552 204.183 21.4852C206.713 22.3252 208.533 23.7352 208.233 24.6352Z",
    fill: "url(#paint52_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M227.003 33.3853C226.773 34.0953 224.743 34.0653 222.473 33.3253C220.203 32.5753 218.563 31.3953 218.793 30.6853C219.023 29.9753 221.053 30.0053 223.323 30.7453C225.593 31.4953 227.233 32.6753 227.003 33.3853Z",
    fill: "url(#paint53_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M236.723 44.5552C236.563 45.0452 234.913 44.9452 233.053 44.3352C231.183 43.7152 229.803 42.8252 229.963 42.3252C230.123 41.8352 231.773 41.9352 233.633 42.5452C235.503 43.1652 236.883 44.0652 236.723 44.5552Z",
    fill: "url(#paint54_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M227.923 48.9553C227.813 49.2953 226.523 49.1753 225.043 48.6953C223.563 48.2153 222.453 47.5353 222.573 47.1953C222.683 46.8553 223.973 46.9753 225.453 47.4553C226.933 47.9353 228.033 48.6053 227.923 48.9553Z",
    fill: "url(#paint55_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.754 17.4852C178.524 18.1952 180.164 19.3752 182.434 20.1252C184.704 20.8752 186.724 20.9052 186.964 20.1852C187.204 19.4652 185.554 18.2952 183.284 17.5452C181.014 16.8052 178.994 16.7752 178.754 17.4852Z",
    fill: "url(#paint56_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.304 20.6852C164.144 21.1752 165.524 22.0752 167.394 22.6952C169.264 23.3152 170.904 23.4152 171.064 22.9152C171.224 22.4252 169.844 21.5252 167.974 20.9052C166.114 20.2852 164.464 20.1852 164.304 20.6852Z",
    fill: "url(#paint57_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.763 29.4552C168.653 29.7952 169.753 30.4652 171.233 30.9552C172.713 31.4452 174.003 31.5652 174.113 31.2152C174.223 30.8752 173.123 30.2052 171.643 29.7152C170.163 29.2252 168.873 29.1052 168.763 29.4552Z",
    fill: "url(#paint58_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M222.164 43.0853C223.494 39.0353 214.444 32.4153 201.934 28.2853C189.424 24.1653 178.204 24.1053 176.874 28.1553C176.444 29.4553 177.094 31.0253 178.574 32.6853C178.124 31.8353 177.994 31.0453 178.224 30.3453C179.404 26.7553 189.664 26.9053 201.134 30.6853C212.604 34.4653 220.944 40.4453 219.754 44.0353C219.524 44.7353 218.944 45.2953 218.084 45.7153C220.284 45.2553 221.744 44.3853 222.164 43.0853Z",
    fill: "url(#paint59_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.943 42.2752C213.373 44.0152 206.193 43.2252 197.913 40.4952C189.633 37.7652 183.393 34.1452 183.963 32.3952C184.533 30.6552 191.713 31.4452 199.993 34.1752C208.273 36.9052 214.523 40.5352 213.943 42.2752Z",
    fill: "url(#paint60_linear)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M85.9336 163.635C88.9932 163.635 91.4736 161.155 91.4736 158.095C91.4736 155.036 88.9932 152.555 85.9336 152.555C82.8739 152.555 80.3936 155.036 80.3936 158.095C80.3936 161.155 82.8739 163.635 85.9336 163.635Z",
    fill: "url(#paint61_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M85.9334 162.295C88.253 162.295 90.1334 160.415 90.1334 158.095C90.1334 155.776 88.253 153.895 85.9334 153.895C83.6138 153.895 81.7334 155.776 81.7334 158.095C81.7334 160.415 83.6138 162.295 85.9334 162.295Z",
    fill: "url(#paint62_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M85.9335 160.965C87.5185 160.965 88.8035 159.68 88.8035 158.095C88.8035 156.51 87.5185 155.225 85.9335 155.225C84.3484 155.225 83.0635 156.51 83.0635 158.095C83.0635 159.68 84.3484 160.965 85.9335 160.965Z",
    fill: "url(#paint63_linear)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M85.9333 159.625C86.7783 159.625 87.4633 158.94 87.4633 158.095C87.4633 157.25 86.7783 156.565 85.9333 156.565C85.0883 156.565 84.4033 157.25 84.4033 158.095C84.4033 158.94 85.0883 159.625 85.9333 159.625Z",
    fill: "url(#paint64_linear)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M234.893 166.605C239.073 164.925 243.833 166.955 245.513 171.125C247.193 175.305 245.163 180.065 240.993 181.745C236.823 183.425 232.053 181.395 230.373 177.225C228.693 173.055 230.723 168.295 234.893 166.605ZM240.573 180.695C244.163 179.245 245.913 175.145 244.463 171.555C243.013 167.965 238.913 166.215 235.323 167.665C231.733 169.115 229.983 173.215 231.433 176.805C232.883 180.405 236.983 182.145 240.573 180.695Z",
    fill: "url(#paint65_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M236.253 169.965C236.543 169.845 236.873 169.985 236.993 170.285L238.723 174.565C238.843 174.855 238.703 175.185 238.403 175.305C238.113 175.425 237.783 175.285 237.663 174.985L235.933 170.705C235.813 170.415 235.953 170.085 236.253 169.965Z",
    fill: "url(#paint66_linear)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M239.153 177.925C239.562 177.925 239.893 177.594 239.893 177.185C239.893 176.777 239.562 176.445 239.153 176.445C238.744 176.445 238.413 176.777 238.413 177.185C238.413 177.594 238.744 177.925 239.153 177.925Z",
    fill: "url(#paint67_linear)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.384 51.6452C104.013 51.6452 106.144 49.5141 106.144 46.8852C106.144 44.2564 104.013 42.1252 101.384 42.1252C98.7551 42.1252 96.624 44.2564 96.624 46.8852C96.624 49.5141 98.7551 51.6452 101.384 51.6452Z",
    fill: "url(#paint68_linear)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.384 50.5053C103.383 50.5053 105.004 48.8845 105.004 46.8853C105.004 44.886 103.383 43.2653 101.384 43.2653C99.3844 43.2653 97.7637 44.886 97.7637 46.8853C97.7637 48.8845 99.3844 50.5053 101.384 50.5053Z",
    fill: "url(#paint69_linear)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.384 49.3553C102.748 49.3553 103.854 48.2494 103.854 46.8853C103.854 45.5211 102.748 44.4153 101.384 44.4153C100.02 44.4153 98.9141 45.5211 98.9141 46.8853C98.9141 48.2494 100.02 49.3553 101.384 49.3553Z",
    fill: "url(#paint70_linear)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.384 48.2052C102.113 48.2052 102.704 47.6142 102.704 46.8852C102.704 46.1562 102.113 45.5652 101.384 45.5652C100.655 45.5652 100.064 46.1562 100.064 46.8852C100.064 47.6142 100.655 48.2052 101.384 48.2052Z",
    fill: "url(#paint71_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 218.709,
    y1: 137.79,
    x2: 243.49,
    y2: 120.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 226.083,
    y1: 147.816,
    x2: 233.039,
    y2: 147.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 226.922,
    y1: 147.816,
    x2: 232.2,
    y2: 147.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 227.76,
    y1: 147.816,
    x2: 231.361,
    y2: 147.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 228.598,
    y1: 147.816,
    x2: 230.523,
    y2: 147.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 176.441,
    y1: 61.7641,
    x2: 184.291,
    y2: 53.9139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 177.387,
    y1: 60.8177,
    x2: 183.344,
    y2: 54.8602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 178.333,
    y1: 59.8715,
    x2: 182.398,
    y2: 55.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 179.28,
    y1: 58.925,
    x2: 181.452,
    y2: 56.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 113.679,
    y1: 230.89,
    x2: 129.389,
    y2: 215.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 115.572,
    y1: 228.996,
    x2: 127.495,
    y2: 217.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 117.467,
    y1: 227.103,
    x2: 125.602,
    y2: 218.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 119.36,
    y1: 225.209,
    x2: 123.708,
    y2: 220.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 55.6119,
    y1: 93.1662,
    x2: 67.9571,
    y2: 93.1662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 57.1003,
    y1: 93.1662,
    x2: 66.4691,
    y2: 93.1662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 58.588,
    y1: 93.1662,
    x2: 64.9804,
    y2: 93.1662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 60.0763,
    y1: 93.1662,
    x2: 63.4924,
    y2: 93.1662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 107.072,
    y1: 59.821,
    x2: 101.572,
    y2: 64.6543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19788E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 150.009,
    y1: 59.4711,
    x2: 143.926,
    y2: 66.4711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19788E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 103.095,
    y1: 63.1417,
    x2: 91.6782,
    y2: 73.5584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19788E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 157.605,
    y1: 59.2513,
    x2: 149.272,
    y2: 77.9179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19788E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 170.401,
    y1: 121.856,
    x2: 77.5673,
    y2: 129.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19788E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4451"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 173.926,
    y1: 128.891,
    x2: 80.0925,
    y2: 138.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 115.348,
    y1: 121.208,
    x2: 144.348,
    y2: 61.8751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 131.754,
    y1: 71.1398,
    x2: 119.754,
    y2: 85.6398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19788E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 110.652,
    y1: 85.3222,
    x2: 105.375,
    y2: 91.2667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19788E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 146.59,
    y1: 85.3279,
    x2: 141.757,
    y2: 91.0501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19788E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 126.367,
    y1: 107.685,
    x2: 126.367,
    y2: 104.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#412789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B40BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 107.924,
    y1: 143.179,
    x2: 44.1024,
    y2: 169.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 67.2322,
    y1: 111.943,
    x2: 2.56554,
    y2: 155.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 36.7629,
    y1: 116.984,
    x2: 40.2269,
    y2: 145.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 37.9306,
    y1: 126.76,
    x2: 39.0592,
    y2: 136.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 9.37882,
    y1: 134.686,
    x2: 38.5082,
    y2: 99.1804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 226.033,
    y1: 108.856,
    x2: 175.367,
    y2: 151.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 157.424,
    y1: 126.351,
    x2: 223.32,
    y2: 171.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 117.828,
    y1: 136.213,
    x2: 52.6127,
    y2: 242.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 140.464,
    y1: 131.856,
    x2: 207.563,
    y2: 236.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 29.0324,
    y1: 169.195,
    x2: 19.1991,
    y2: 217.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 256.204,
    y1: 161.496,
    x2: 216.871,
    y2: 188.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 192.084,
    y1: 71.6104,
    x2: 178.733,
    y2: 95.4108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 126.367,
    y1: 116.815,
    x2: 126.367,
    y2: 39.5333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#3FA9F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 173.673,
    y1: 101.114,
    x2: 79.451,
    y2: 121.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 126.367,
    y1: 31.2966,
    x2: 126.367,
    y2: 39.1304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 142.478,
    y1: 37.042,
    x2: 114.034,
    y2: 54.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 25.7945,
    y1: 179.672,
    x2: 30.0445,
    y2: 198.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 31.6661,
    y1: 178.317,
    x2: 35.9161,
    y2: 196.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 197.139,
    y1: 130.306,
    x2: 185.861,
    y2: 138.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 197.926,
    y1: 131.378,
    x2: 186.648,
    y2: 139.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 240.369,
    y1: 28.4892,
    x2: 151.936,
    y2: 30.3107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 240.36,
    y1: 28.0603,
    x2: 151.928,
    y2: 29.8819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 240.004,
    y1: 10.7805,
    x2: 151.571,
    y2: 12.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 240.498,
    y1: 34.7822,
    x2: 152.065,
    y2: 36.6038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 240.242,
    y1: 22.3796,
    x2: 151.81,
    y2: 24.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 218.786,
    y1: 30.8258,
    x2: 227.076,
    y2: 33.2604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 229.96,
    y1: 42.441,
    x2: 236.789,
    y2: 44.4465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 222.576,
    y1: 47.2813,
    x2: 227.984,
    y2: 48.8696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 178.745,
    y1: 17.6297,
    x2: 187.035,
    y2: 20.0642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 164.3,
    y1: 20.8022,
    x2: 171.129,
    y2: 22.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 168.765,
    y1: 29.5475,
    x2: 174.173,
    y2: 31.1358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 240.496,
    y1: 34.6379,
    x2: 152.063,
    y2: 36.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 240.533,
    y1: 36.4891,
    x2: 152.101,
    y2: 38.3107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 80.3939,
    y1: 158.093,
    x2: 91.4731,
    y2: 158.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 81.7293,
    y1: 158.093,
    x2: 90.1373,
    y2: 158.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 83.0649,
    y1: 158.093,
    x2: 88.8019,
    y2: 158.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 84.4003,
    y1: 158.093,
    x2: 87.4661,
    y2: 158.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 245.075,
    y1: 179.763,
    x2: 231.064,
    y2: 168.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 239.472,
    y1: 165.198,
    x2: 234.533,
    y2: 182.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 242.376,
    y1: 166.038,
    x2: 237.438,
    y2: 183.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 96.6162,
    y1: 46.8877,
    x2: 106.144,
    y2: 46.8877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 97.7644,
    y1: 46.8878,
    x2: 104.995,
    y2: 46.8878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 98.9134,
    y1: 46.8878,
    x2: 103.847,
    y2: 46.8878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 100.062,
    y1: 46.8877,
    x2: 102.699,
    y2: 46.8877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.aa825db638327a8633847438e777aba8.svg";
export { ForwardRef as ReactComponent };